export default "__VITE_ASSET__CAvqqZAh__"